<template>
  <div v-if="!overflowing">
    <div
      v-for="(answer) in options"
      :key="answer.questionId && answer.id"
      class="d-inline"
    >
      <span
        :id="answer.id"
        class="answer-label"
      >
        {{ answer.answer }}
        <b-button
          variant="link-secondary p-0"
          @click="removeAnswer(answer)"
        >
          <GjIcon
            size="20"
            name="Close"
          />
        </b-button>
      </span>
    </div>
  </div>
  <div v-else>
    <div
      v-for="(answer, answerIndex) in options"
      :key="answer.questionId && answer.id"
      class="d-inline"
    >
      <span
        v-if="answerIndex < index"
        :id="answer.id"
        class="answer-label"
      >
        {{ answer.answer }}
        <b-button
          variant="link-secondary p-0"
          @click="removeAnswer(answer)"
        >
          <GjIcon
            name="Close"
            size="20"
          />
        </b-button>
      </span>
    </div>
    <b-dropdown
      v-if="index != -1 && index < options.length"
      no-caret
      size="sm"
      variant="link-secondary"
      class="more-answers-dropdown answer-label-more"
    >
      <template #button-content>
        <span
          class="py-0 px-50"
        >
          <GjIcon
            name="Moreoptions"
            size="22"
          />
        </span>
      </template>

      <b-dropdown-item
        v-for="(answer) in options.slice(index)"
        :key="answer.questionId && answer.id"
        class="d-inline"
      >
        <span
          :id="answer.id"
          class="answer-label"
        >
          {{ answer.answer }}
          <b-button
            variant="link-secondary p-0"
            class="remove-btn"
            @click="removeAnswer(answer)"
          >
            <GjIcon
              name="Close"
              size="20"
            />
          </b-button>
        </span>
      </b-dropdown-item>
    </b-dropdown>
  </div>
</template>

<script>
import GjIcon from '@gjirafatech/gjirafa-icons/Icon.vue'
import {
  ref, watch, onMounted,
} from '@vue/composition-api'

export default {
  components: {
    GjIcon,
  },
  props: {
    options: {
      type: [Array, Object],
    },
    optionsKey: {
      type: [Number],
    },
  },
  setup(props, context) {
    const overflowing = ref(false)
    const index = ref(0)

    const isOverflow = () => {
      setTimeout(() => {
        const parent = document.querySelector('.answers-content')
        const childs = document.querySelectorAll(`.answers-box-${props.optionsKey} .answer-label`)
        const parentWidth = parent.offsetWidth
        let width = 0
        for (let i = 0; i < childs.length; i += 1) {
          width += childs[i].offsetWidth
          if (width > parentWidth - 70) {
            overflowing.value = true
            index.value = props.options.findIndex(x => x.answer === childs[i].innerText.trim())
            break
          }
        }
      }, 10)
    }

    onMounted(() => {
      isOverflow()
    })

    const removeAnswer = answer => {
      context.emit('removeAnswer', answer)
    }

    watch(props, () => {
      if (props.options.length > 0) {
        isOverflow()
      }
    })

    return {
      overflowing,
      index,
      removeAnswer,
    }
  },
}
</script>
<style lang="scss">
.more-answers-dropdown{
  button.dropdown-toggle{
    padding: 0;
  }
  ul.dropdown-menu {
    padding: 4px;
    li > a.dropdown-item {
      padding: 4px;
      height: 34px;
      cursor: default;
      &:hover {
        background-color: #fff !important;
      }
    }
  }
}
.remove-btn{
  border: none;
}
</style>
